"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var Icon_1 = __importDefault(require("./Icon"));
var Tooltip_1 = __importDefault(require("./Tooltip"));
var context_1 = require("../../context");
var store_1 = require("../../store");
var styles_1 = require("../../styles");
var IoIosArrowDown_1 = require("@react-icons/all-files/io/IoIosArrowDown");
function TokenSelectButton(_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b, onClick = _a.onClick, hideArrow = _a.hideArrow, customUi = _a.customUi, customButtonElement = _a.customButtonElement;
    var translations = (0, context_1.useTwapContext)().translations;
    var wrongNetwork = (0, store_1.useTwapStore)(function (state) { return state.wrongNetwork; });
    var maker = (0, store_1.useTwapStore)(function (state) { var _a; return (_a = state.lib) === null || _a === void 0 ? void 0 : _a.maker; });
    var selectTokenWarning = function () {
        if (wrongNetwork) {
            return translations.switchNetwork;
        }
        if (!maker) {
            return translations.connect;
        }
    };
    var warning = selectTokenWarning();
    var _onClick = function () {
        if (warning)
            return;
        onClick();
    };
    var Btn = customButtonElement || StyledContainer;
    return ((0, jsx_runtime_1.jsx)(Tooltip_1.default, __assign({ text: warning }, { children: (0, jsx_runtime_1.jsx)(Btn, __assign({ className: "twap-token-select ".concat(className), onClick: _onClick }, { children: (0, jsx_runtime_1.jsx)(styles_1.StyledRowFlex, { children: customUi ? ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: customUi })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(styles_1.StyledOneLineText, { children: translations.selectToken }), !hideArrow && (0, jsx_runtime_1.jsx)(Icon_1.default, { icon: (0, jsx_runtime_1.jsx)(IoIosArrowDown_1.IoIosArrowDown, { size: 20 }) })] })) }) })) })));
}
exports.default = TokenSelectButton;
var StyledContainer = (0, material_1.styled)("div")({
    cursor: "pointer",
});
